import { render, staticRenderFns } from "./_Detail.vue?vue&type=template&id=b13c7638"
import script from "./_Detail.vue?vue&type=script&lang=js"
export * from "./_Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports